export default __webpack_public_path__ + "static/media/ArtsDept.34db5f27.png";